import { fetchAuthSession } from 'aws-amplify/auth';

export const fetchISolvedEmployeeSchedule = async (employeeId) => {
  try {
    const session = await fetchAuthSession();
    const authToken = `Bearer ${session.tokens.idToken}`;

    const response = await fetch(
      'https://ugczaq3r89.execute-api.us-east-1.amazonaws.com/dev/getisolvedemployeeschedule',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: authToken,
        },
        body: JSON.stringify({
          queryStringParameters: { employeeId },
        }),
      }
    );

    console.warn('fetchISolvedEmployeeSchedule response:', response);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error in fetchISolvedEmployeeSchedule:', response.status, errorText);
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    const dataJSON = await response.json();
    return dataJSON;
  } catch (error) {
    console.error('fetchISolvedEmployeeSchedule failed:', error.message);
    return null;
  }
};